import React, { PureComponent } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { getDistricts, getDistrictFilter } from '../../selectors'
import { mergeQs } from '../../utils'
import { filterStyle } from '../../styles/theme'
import { FormControl, FormHelperText } from 'material-ui-next/Form'
import breakpoints from '../../styles/breakpoints'
import { MenuItem } from 'material-ui-next/Menu'
import Icon from 'material-ui-next/Icon'
import Select from 'material-ui-next/Select'
import { withStyles } from 'material-ui-next/styles'
import Input, { InputLabel } from 'material-ui-next/Input'
import IconButton from 'material-ui-next/IconButton'
import classNames from 'classnames'

const styles = theme => ({
  ...theme.swapick.styles.toolbars,
  select: {
    width: '100px',
    marginRight: '16px',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    position: 'relative',
    fontSize: 14,
    [`@media (max-width: ${breakpoints.xs})`]: {
      width: '100%',
    },
  },
  label: {
    fontSize: 14,
  },
  select: {
    fontSize: 14,
  },
  formControl: {
    minWidth: 120,
  },
  menuItem: {
    ...theme.swapick.styles.dropdown.menuItem,
  },
  clear: {
    marginTop: 17,
    width: 27,
    height: 27,
  },
  clearIcon: {
    color: theme.swapick.colors.neutral,
    fontSize: 18,
  },
  marginRight: {
    marginRight: 30,
    [`@media (max-width: ${breakpoints.xs})`]: {
      minWidth: '100%',
      paddingRight: 30,
      marginRight: 0,
    },
  },
  transparent: {
    color: theme.swapick.colors.secondaryToolbar,
  },
  w100Mobile: {
    [`@media (max-width: ${breakpoints.xs})`]: {
      width: '100%',
    },
  },
})

class DistrictFilter extends PureComponent {
  clearSelection = () => {
    const { history, location } = this.props
    history.push(
      `${location.pathname}?${mergeQs(location, { district: undefined })}`
    )
  }

  handleChange = e => {
    const { history, location } = this.props
    const district = e.target.value
    history.push(`${location.pathname}?${mergeQs(location, { district })}`)
  }

  render() {
    const { districtFilter, districts, classes, scale = false } = this.props
    return (
      <div
        className={classNames(classes.toolbarGroup, classes.w100Mobile, {
          [classes.marginRight]: !districtFilter,
        })}>
        <form className={classes.container}>
          <FormControl
            className={classNames(classes.formControl, classes.w100Mobile)}>
            <InputLabel htmlFor="districts" className={classes.label}>
              Provincia
            </InputLabel>
            <Select
              className={classes.select}
              input={<Input id="districts" />}
              value={districtFilter}
              onChange={this.handleChange}>
              {districts.map(district => (
                <MenuItem
                  key={district.automobile}
                  value={district.automobile}
                  classes={{
                    root: classes.menuItem,
                    selected: classes.selectedMenuItem,
                  }}>
                  {district.nome}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </form>
        {districtFilter && (
          <IconButton
            classes={{ icon: classes.clearIcon, root: classes.clear }}
            onClick={this.clearSelection}
            aria-label="Provincia">
            <Icon>close</Icon>
          </IconButton>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  districtFilter: getDistrictFilter(state, ownProps.location, 'automobile'),
  districts: getDistricts(state),
})

export default withRouter(
  withStyles(styles)(connect(mapStateToProps)(DistrictFilter))
)



// WEBPACK FOOTER //
// ./src/common/TopBar/DistrictFilter.js